// extracted by mini-css-extract-plugin
export default {"tag":"tag_tag__V73Fx","primary":"tag_primary__3jMj0","secondary":"tag_secondary__B33Ol"};